var render = function render(){var _vm=this,_c=_vm._self._c;return _c('role-edit',{attrs:{"av-flow":"","admin":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }